import { render, staticRenderFns } from "./superchangeform.vue?vue&type=template&id=a6693378&scoped=true&"
import script from "./superchangeform.vue?vue&type=script&lang=js&"
export * from "./superchangeform.vue?vue&type=script&lang=js&"
import style0 from "./superchangeform.vue?vue&type=style&index=0&id=a6693378&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6693378",
  null
  
)

export default component.exports